import React, { useEffect, useState } from 'react';
import { Button, TextField, Box, Typography, Alert, CircularProgress, Link } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { persistSessionRole } from '../../services/auth';
import { USER_ROLES } from '../../constants';
import AuthPasswordField from './AuthPasswordField';
import AuthPageShell from './AuthPageShell';
import { authPrimaryButtonSx, textFieldStyle } from './AuthStyles';

const Login = () => {
  useEffect(() => {
    persistSessionRole(USER_ROLES.ADMIN);
  }, []);
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const result = await login({
        email: credentials.email,
        password: credentials.password,
      });
      if (result.success) {
        navigate('/dashboard');
      } else {
        setError(result.message || 'Invalid credentials. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthPageShell
      title="Admin Login"
      footer={
        <Typography variant="body2" align="center" color="text.secondary">
          <Link
            component={RouterLink}
            to="/partner-login"
            color="primary.main"
            underline="hover"
            fontWeight={500}
          >
            Sign in as Partner
          </Link>
        </Typography>
      }
    >
      {error ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      ) : null}
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Email"
          value={credentials.email}
          onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
          required
          disabled={isLoading}
          sx={textFieldStyle}
        />
        <AuthPasswordField
          value={credentials.password}
          onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
          required
          disabled={isLoading}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
          <Link
            component={RouterLink}
            to="/forgot-password"
            color="primary.main"
            underline="hover"
            variant="body2"
            fontWeight={500}
          >
            Forgot password?
          </Link>
        </Box>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disableElevation
          disabled={isLoading}
          sx={authPrimaryButtonSx}
        >
          {isLoading ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <CircularProgress size={22} color="inherit" />
              Signing in…
            </Box>
          ) : (
            'Log In'
          )}
        </Button>
      </form>
    </AuthPageShell>
  );
};

export default Login;
